<script>
import { mapActions, mapState } from "vuex";

import errorMixin from "@/mixins/errorMixin";
import Modal from "@/components/_Shared/Modal";
import StepText from "@/components/SignUp/Steps/StepText";
import TermsOfUse from "@/components/TermsOfUse/TermsOfUse";

export default {
  mixins: [errorMixin],

  components: {
    StepText,
    Modal,
    TermsOfUse
  },

  data() {
    return {
      cpf: "",
      terms: false,
      loading: false,
      showModal: false
    };
  },

  computed: {
    ...mapState("signUp", ["physical", "fieldErrors"])
  },

  methods: {
    ...mapActions("signUp", ["prevStep", "setPhysical", "register"]),

    async submit() {
      this.loading = true;
      try {
        let dataIsValid = await this.$validator.validateAll();
        if (!dataIsValid) throw "Existem dados incorretos ou incompletos!";
        await this.setPhysical({ cpf: this.cpf });
        await this.register();
        this.$router.push({ name: "dashboard" });
      } catch (e) {
        this.inputErrors(this.fieldErrors);

        let duration = e.duration || 5000;
        let message = e.message || e;

        this.$toasted.error(message, { duration });
      }
      this.loading = false;
    }
  },

  mounted() {
    document.querySelector("input").focus();
    this.inputErrors(this.fieldErrors);
    if (this.physical) Object.assign(this.$data, this.physical);
  },

  beforeDestroy() {
    this.setPhysical({ cpf: this.cpf });
  }
};
</script>

<template>
  <div>
    <form @submit.prevent="submit()">
      <step-text>Quase lá... Agora precisamos saber o seu CPF para finalizar seu cadastro.</step-text>

      <base-input
        :error="errors.first('cpf')"
        v-validate="'required|numeric|length:11'"
        v-model="cpf"
        label="CPF"
        name="cpf"
        data-vv-as="CPF"
        mask="###.###.###-##"
      />

      <base-flex align="center" justify="start">
        <label class="checkbox">
          <input
            :error="errors.first('terms')"
            name="terms"
            v-model="terms"
            v-validate="'required'"
            type="checkbox"
          >
          Declaro que li e aceito os&nbsp;
        </label>

        <small
          class="text-purple pointer"
          @click="showModal = true"
        >
          Termos de Uso e Serviços
        </small>
      </base-flex>

      <base-flex justify="end" class="mt-10">
        <base-button @click="prevStep()" outlined>voltar</base-button>
        <base-button type="submit" color="green" :loading="loading" :disabled="!terms">cadastrar</base-button>
      </base-flex>
    </form>

    <modal
      v-if="showModal"
      size="md"
      @close="showModal = false"
    >
      <template slot="header">
        <img src="../../../../../../static/logo.svg" class="logo-color">
      </template>

      <template slot="body">
        <div class="terms">
          <TermsOfUse/>
        </div>
      </template>

      <template slot="footer">
        <div  class="footer">
          <label class="checkbox">
            <input
              name="terms"
              v-model="terms"
              v-validate="'required'"
              type="checkbox"
            >
            Declaro que li e aceito os Termos de Uso e Serviços
          </label>

          <button class="btn bg-purple-outline" @click="showModal = false">fechar</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<style scoped>
.checkbox {
  display: flex;
  align-items: center;
  font-size: 12px;
}

small {
  text-decoration: underline;
  font-weight: 500;
  margin-bottom: 0;
}

.logo-color {
  width: 310px;
  height: 54px;
  display: block;
}

.terms {
  height: 400px;
  padding: 8px 12px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp/Steps/Accountable/Types/Physical.vue